import { useParamsSearch } from '@anytag/shared-hooks';
import { AnalyticsSearchSchemaType } from '../schemaTypes';

export const useAnalyticsFilter = () => useParamsSearch<AnalyticsSearchSchemaType>();
